import { HttpPromise } from "@shared/svelte/Modules/ApiService";

export const loadCart = async () => {
  const url = "/api/retailer/cart";
  return await HttpPromise({ method: "GET", url });
};
